module.exports = __webpack_public_path__ + "media/images/crm/icon-pie-chart-0a101d64fa998696a1ea466778b5b14e.png";